<template>
  <a-button class="count-btn" @click="click" :disabled="disabled" :loading="loading">
    <span class="msg">{{ realMsg }}</span>
  </a-button>
</template>

<script>
import { api_post } from '@/utils/http.ts'
import { msgTip } from '@/utils/urlUtils'

const TIMEOUT_SECONDS = 60
let timeback = null
export default {
  // 获取短信验证码
  name: 'CountBtn',
  data() {
    return {
      wait: TIMEOUT_SECONDS,
      disabled: false,
      loading: false,
      realMsg: this.msg,
      codeLength: 11
    }
  },
  watch: {
    clean: function(val) {
      if (!val) {
        this.disabled = false
        this.loading = false
        this.realMsg = this.msg
        this.wait = TIMEOUT_SECONDS
        clearTimeout(this.timeback)
      }
    }
  },
  props: {
    clean: {
      type: Boolean,
      default: true
    },
    value: {
      type: String,
      default: ''
    },
    msg: {
      type: String,
      default: '发送验证码'
    },
    usage: {
      type: Object,
      default: function() {
        return { usage: '' }
      }
    },
    address: {
      type: String,
      default() {
        return '/search/api/auth/send-sms-code'
      }
    }
  },
  methods: {
    valid(val) {
      return /^1\d{10}$/.test(val)
    },
    async click() {
      if (this.value && this.valid(this.value)) {
        // 这里调用发送短信的接口，成功调用之后再开始计时。点击到接口返回数据之间，btn加入loading状态。
        this.loading = true
        let pdata = Object.assign({ username: this.value }, this.usage)
        // let pdata = { username: this.value }
        let rdata = await api_post(this.address, pdata)
        if (rdata.success) {
          msgTip({ type: 'success', msg: rdata.msg })
          this.time()
        } else {
          if (this.usage.usage) {
            this.$emit('result', rdata.error)
          } else {
            msgTip({ type: 'error', msg: rdata.error })
          }
        }
        this.loading = false
      } else {
        this.$emit('result', '请输入11位手机号码')
        // msgTip({ type: 'info', msg: '请输入11位手机号码！' })
      }
    },
    time() {
      if (this.wait === 1) {
        this.wait = TIMEOUT_SECONDS
        this.disabled = false
        this.realMsg = this.msg
      } else {
        // debugger
        if (!this.clean) {
          clearTimeout(this.timeback)
        } else {
          this.wait--
          this.disabled = true
          this.realMsg = '重发' + this.wait + 's'
          timeback = setTimeout(() => {
            this.time()
          }, 1000)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
